import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useTimeFilterContext } from '../../context/TimeFilterContext/TimeFilterContext.js';
import { useTimeFilterItems } from './hooks/use-time-filter-items.js';
import PreferredTime from './PreferredTime.js';

const PreferredTimeContainer = (_param)=>{
    var { labels: externalLabels , onPreferredTimeClick , onPreferredTimeFilterClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "labels",
        "onPreferredTimeClick",
        "onPreferredTimeFilterClick"
    ]);
    const { getLabel , getFormattedLabel  } = useIntl();
    const [, { options  }] = useTimeFilterContext();
    const [, { noPreferenceItem , items: timeFilterItems , activeItem  }] = useTimeFilterItems({
        allowSingleFilter: true
    });
    const [openPreferredTimePopup, setOpenPreferredTimePopup] = React.useState(false);
    const withPreferredTimeFilters = options.length > 0;
    var ref, ref1;
    const labels = React.useMemo(()=>{
        return {
            title: (ref = externalLabels === null || externalLabels === void 0 ? void 0 : externalLabels.title) !== null && ref !== void 0 ? ref : getLabel('appointments.component.preferredTime.title'),
            preferredTime: (ref1 = externalLabels === null || externalLabels === void 0 ? void 0 : externalLabels.preferredTime) !== null && ref1 !== void 0 ? ref1 : getLabel('appointments.component.preferredTime.preferredTime')
        };
    }, [
        getLabel,
        externalLabels
    ]);
    const preferredTimeFilterItems = React.useMemo(()=>{
        return [
            noPreferenceItem,
            ...timeFilterItems
        ].map((item)=>{
            return swcHelpers.objectSpread({}, item, {
                onClick: ()=>{
                    setOpenPreferredTimePopup(false);
                    onPreferredTimeFilterClick === null || onPreferredTimeFilterClick === void 0 ? void 0 : onPreferredTimeFilterClick(item);
                    item.onClick();
                }
            });
        });
    }, [
        noPreferenceItem,
        timeFilterItems,
        onPreferredTimeFilterClick
    ]);
    const preferredTimeFilter = React.useMemo(()=>{
        if (!activeItem) {
            return;
        }
        return {
            label: activeItem.label,
            ariaLabels: {
                inactive: getFormattedLabel('appointments.component.quickSelectFilter.inactive', {
                    labelData: {
                        description: activeItem.label
                    }
                }),
                active: getFormattedLabel('appointments.component.quickSelectFilter.active', {
                    labelData: {
                        description: activeItem.label
                    }
                })
            },
            active: activeItem.active,
            onClick: activeItem.onClick
        };
    }, [
        getFormattedLabel,
        activeItem
    ]);
    const onClickPreferredTime = React.useCallback(()=>{
        onPreferredTimeClick === null || onPreferredTimeClick === void 0 ? void 0 : onPreferredTimeClick();
        setOpenPreferredTimePopup(true);
    }, [
        onPreferredTimeClick
    ]);
    const onPreferredTimePopupClose = React.useCallback(()=>setOpenPreferredTimePopup(false)
    , []);
    return /*#__PURE__*/ React.createElement(PreferredTime, swcHelpers.extends({}, rest, {
        labels: labels,
        onClickPreferredTime: onClickPreferredTime,
        withPreferredTimeFilters: withPreferredTimeFilters,
        openPreferredTimePopup: openPreferredTimePopup,
        onPreferredTimePopupClose: onPreferredTimePopupClose,
        preferredTimeFilterItems: preferredTimeFilterItems,
        preferredTimeFilter: preferredTimeFilter
    }));
};

export { PreferredTimeContainer as default };
//# sourceMappingURL=PreferredTimeContainer.js.map
